<template>
    <div>
        <zm-row>
            Path: <zm-select v-model="path.namespace" class="select-inline" placeholder="namespace" filterable clearable
            @change="setNamespace" popper-class="select-popper">
                <zm-option v-for="item in namespaceList" :key="item" :value="item"></zm-option>
            </zm-select>
            <zm-select v-model="path.applicationId" placeholder="Application" filterable clearable @change="handelAppChange()"
                class="select-inline" popper-class="select-popper" :width-limit="{ disableTip: true }">
                <zm-option v-for="item in applicationList" :key="item.id" :label="item.applicationName" :value="item.id"></zm-option>
            </zm-select>
            <zm-select v-for="(item, index) in path.prefixPath" :key="index" v-model="path.prefixPath[index]" filterable clearable
                @change="handlePrefixChange(index, true)" class="select-inline">
                <zm-option v-for="item in pathList[index]" :key="item.id" :label="item.path" :value="item.path"></zm-option>
            </zm-select>
            Alias: <zm-input v-model="filter.alias" style="width: 200px" @keyup.enter.native="fetchData"></zm-input>
            <zm-button type="icon" icon="zm-icon-search" @click="fetchData" class="btn-in-line"></zm-button>
        </zm-row>
        <div class="table-container">
            <zm-table :data="list" v-loading="loading" class="share-range-table">
                <zm-table-column type="index" width="50px"></zm-table-column>
                <zm-table-column prop="alias" label="alias" width="240px"></zm-table-column>
                <zm-table-column prop="shareType" label="share type" width="140px"></zm-table-column>
                <zm-table-column prop="fullPath" label="fullpath" width="240px"></zm-table-column>
                <zm-table-column prop="hash" label="sharedApplicationPaths" :show-overflow-tooltip="false">
                    <!-- eslint-disable-next-line -->
                    <template slot="header" slot-scope="scope">
                        sharedApplicationPaths<zm-button size="small" class="btn-contain" type="icon" title="show secrets"
                        :icon="showSecretsVisible ? 'zm-icon-eyes-close' : 'zm-icon-eyes'" @click="showShares()"></zm-button>
                    </template>
                    <template slot-scope="scope">
                        <span v-if="scope.row.sharedApplicationPaths.length">
                            {{ scope.row.showShareLine ? scope.row.sharedApplicationPaths.join() : scope.row.sharedApplicationPaths.slice(0, 10).join() }}
                        </span>
                        <zm-button size="small" type="icon" :icon="scope.row.showShareLine ? 'zm-icon-eyes' : 'zm-icon-eyes-close'"
                        title="show secret" @click="showShare(scope.row.id)" v-if="scope.row.sharedApplicationPaths.length > 10"></zm-button>
                    </template>
                </zm-table-column>
            </zm-table>
            <div style="text-align: center" class="pagination-wrap">
                <zm-pagination @current-change="fetchData"
                    @size-change="handleSizeChange"
                    :current-page.sync="filter.pageNo"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="filter.pageSize"
                    layout="sizes, total, prev, pager, next, jumper"
                    :total="total">
                </zm-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import { listNamespace, listApplication, listPath, secretShareRangePageList } from '@/api/index'
export default {
    name: 'secretShareRange',
    data () {
        return {
            list: [],
            total: 0,
            loading: false,
            namespaceList: [],
            applicationList: [],
            pathList: [[]],
            path: {
                namespace: '',
                application: '',
                applicationId: '',
                prefixPath: []
            },
            filter: {
                prefixPath: '',
                alias: '',
                pageSize: 10,
                pageNo: 1
            },
            failedList: [],
            failedVisible: false
        }
    },
    computed: {
        showSecretsVisible () {
            var data = false
            this.list.map(item => {
                if (!item.showShareLine && item.sharedApplicationPaths.length > 10) {
                    data = true
                }
            })
            return data
        }
    },
    created () {
        localStorage.path = this.$route.path
        localStorage.params = ''
        this.fetchNamespace()
    },
    watch: {
        'path.namespace' () {
            if (!this.$route.query.instance) {
                this.setURL()
            }
        },
        'path.applicationId' () {
            if (!this.$route.query.instance) {
                this.setURL()
            }
        },
        'path.prefixPath' () {
            if (!this.$route.query.instance) {
                this.setURL()
            }
        },
        'filter.prefixPath' () {
            this.setURL()
        },
        'filter.alias' () {
            this.setURL()
        },
        'filter.pageSize' () {
            this.setURL()
        },
        'filter.pageNo' () {
            this.setURL()
        }
    },
    methods: {
        setURL () {
            const data = {
                path: this.path,
                alias: this.filter.alias,
                prefixPath: this.filter.prefixPath,
                pageSize: this.filter.pageSize,
                pageNo: this.filter.pageNo
            }
            var url = `${location.href.split('?params=')[0]}?params=${JSON.stringify(data)}`
            history.pushState({ url: url }, '', url)
            localStorage.params = JSON.stringify(data)
        },
        fetchNamespace () {
            if (localStorage.namespaceList) {
                this.namespaceList = JSON.parse(localStorage.namespaceList)
            } else {
                listNamespace().then(response => {
                    this.namespaceList = response
                })
            }
        },
        setNamespace (val) {
            if (val) {
                localStorage.namespace = this.path.namespace
                this.fetchApplication()
            }
            this.fetchData()
        },
        fetchApplication () {
            this.path.namespace = localStorage.namespace
            if (this.path.namespace) {
                listApplication(this.path.namespace, '', 'secret/secret').then(response => {
                    this.applicationList = response.data
                    if (this.path.applicationId) {
                        const data = {
                            namespace: this.path.namespace,
                            applicationId: this.path.applicationId,
                            parentFullPath: ''
                        }
                        listPath(data).then(response => {
                            this.pathList = [response.data, []]
                            this.path.prefixPath = ['']
                        })
                    }
                })
            }
        },
        fetchPath (index, prefixPath, applicationId) {
            var path = index ? prefixPath[0] : ''
            this.pathList[index] = []
            for (var i = 1; i < prefixPath.length && i < index; i++) {
                path += (index > i && prefixPath[i]) ? '/' + this.path.prefixPath[i] : ''
            }
            const data = {
                namespace: this.path.namespace,
                applicationId: applicationId,
                parentFullPath: path
            }
            listPath(data).then(response => {
                this.pathList[index] = response.data
                if (this.path.prefixPath[this.path.prefixPath.length - 1] && response.data.length) {
                    this.path.prefixPath.push('')
                    this.pathList.push([])
                }
            })
        },
        showShare (id, showAll) {
            this.list.map(item => {
                if (item.id === id) {
                    console.log(item)
                    // if ((item.showShareLine || showAll) && !item.secret) {
                    //     item.showShareLine = true
                    // } else if (showAll) {
                    //     item.showShareLine = false
                    // } else {
                        item.showShareLine = !item.showShareLine
                    // }
                }
            })
        },
        showShares () {
            if (this.showSecretsVisible) {
                this.list.map(item => {
                    item.showShareLine = true
                })
            } else {
                this.list.map(item => {
                    this.showShare(item.id, true)
                })
            }
        },
        handelAppChange () {
            this.path.prefixPath = ['']
            if (this.path.applicationId) {
                this.applicationList.map(item => {
                    if (item.id === this.path.applicationId) {
                        this.path.application = item.applicationName
                    }
                })
                const data = {
                    namespace: this.path.namespace,
                    applicationId: this.path.applicationId,
                    parentFullPath: ''
                }
                listPath(data).then(response => {
                    this.pathList = [response.data, []]
                })
            } else {
                this.path.application = ''
            }
            this.fetchData()
        },
        handlePrefixChange (index, isQuery) {
            console.log(this.path.prefixPath.indexOf(''))
            if (this.path.prefixPath.indexOf('') !== -1) {
                this.path.prefixPath.splice(this.path.prefixPath.indexOf('') + 1)
            }
            console.log(this.path.prefixPath)
            var reg = /[A-Z]/
            if (isQuery || !reg.test(this.path.prefixPath[index])) {
                for (var i = 0; i < this.path.prefixPath.length; i++) {
                    if (index < i) {
                        this.path.prefixPath[i] = ''
                    }
                }
                this.fetchPath(index + 1, this.path.prefixPath, this.path.applicationId)
                this.fetchData()
            } else {
                this.$message({
                    type: 'warning',
                    message: 'Prefix path cannot contain uppercase letters:' + this.path.prefixPath[index]
                })
            }
        },
        fetchData () {
            const { namespace, application, prefixPath } = this.path
            this.filter.prefixPath = namespace
            if (application) {
                this.filter.prefixPath += '/' + application
                if (prefixPath.length && prefixPath[0]) {
                    prefixPath.map(item => {
                        this.filter.prefixPath += '/' + item
                    })
                }
            }
            if (this.filter.prefixPath.length && this.filter.prefixPath[this.filter.prefixPath.length - 1] === '/') {
                this.filter.prefixPath = this.filter.prefixPath.slice(0, this.filter.prefixPath.length - 1)
            }
            console.log(this.filter.prefixPath)
            const { alias, pageSize, pageNo } = this.filter
            const data = { prefixPath: this.filter.prefixPath, alias, pageSize, pageNo }
            this.loading = true
            secretShareRangePageList(data).then(response => {
                this.list = response.data
                this.list.map(item => {
                    item.showShareLine = false
                })
                this.list = []
                response.data.map(item => {
                    this.list.push({
                        alias: item.alias,
                        fullPath: item.fullPath,
                        id: item.id,
                        shareType: item.shareType,
                        sharedApplicationPaths: item.sharedApplicationPaths,
                        showShareLine: false
                    })
                })
                this.total = response.total
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        handleSizeChange (val) {
            this.filter.pageSize = val
            this.fetchData()
        }
    }
}
</script>
<style>
.header-table.zm-table .zm-scrollbar {
    display: none;
}
.share-range-table.zm-table .cell {
    word-break: break-all;
}
</style>
